import WorkExperienceCard from "./WorkExperienceCard";

export default WorkExperienceCard;
